import axios from "axios";

/*
 * Sends a contact or viewing-request form to the contact-form Lambda
 * (deploy/lambda/contact-form).
 *
 * The browser sends only what the visitor typed. It used to build the whole
 * email - recipient, sender, subject, HTML - and the Lambda sent it as given,
 * which made the endpoint a relay for anyone who found its URL in the bundle.
 *
 * Resolves when the message was accepted; THROWS an Error whose message is safe
 * to show the visitor when it was not. The form used to say "Message Sent"
 * whatever happened, which hid a mistyped sender address for five years.
 */

const PHONE = "020 8946 7171";
const EMAIL = "info@property-people.co.uk";

export const SEND_FAILED = `Sorry, we couldn't send that. Please call us on ${PHONE} or email ${EMAIL}.`;

export default async function sendEnquiry(fields) {
    let res;
    try {
        res = await axios.post(process.env.REACT_APP_EMAIL_SEND_API, { v: 2, ...fields }, { timeout: 20000 });
    } catch (err) {
        throw new Error(SEND_FAILED);
    }

    const data = res && res.data;
    if (data && data.ok === true) return;

    // A Lambda that crashed answers 200 with {errorMessage}, not {ok:false}.
    const error = new Error((data && data.message) || SEND_FAILED);
    error.field = data && data.field;
    error.code = data && data.error;
    throw error;
}
